import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";
interface Props {
  Menuprops: menuInfo;
}

const SN_PUR_RCV_REP_004 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({ grid1: rtn.grid.grid1 });
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_pur_rcv_rep_004_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSources({ grid1: data[0] });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  return (
    <div>
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div>
        <div className="h-[750px]">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              rowSelection: "multiple",
              title: "구매반품정보",
              isEditable: false,
            }}
          />
        </div>
      </div>
    </div>
  );
});

export default SN_PUR_RCV_REP_004;
